module.exports = __webpack_public_path__ + "img/aef5f69.png";